<template>
  <section id="section__wait" class="view-container">
    <div class="width-100">
      <v-row no-gutters class="mt-10">
        <v-col cols="12">
          <p class="font--p-3">서류 제출을 완료했어요!</p>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <img src="@/assets/images/apply/book.png" class="book" />
        </v-col>
      </v-row>

      <v-row no-gutters class="mb-5">
        <v-card class="card">
          <v-col cols="12">
            <v-card-text class="font--m-3 color--nice"
              >아래 대표번호로 <br />
              연락 드릴게요!</v-card-text
            >
          </v-col>
          <v-col cols="12">
            <p class="font-size--18">☎ 1811 - 2807</p>
          </v-col>
        </v-card>
      </v-row>

      <BasicButton @click="next">신청 확인!</BasicButton>
    </div>
  </section>
</template>
<script>
import { closeBrowser } from '@/util'
import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('contract', {
      contractCurrent: 'current',
    }),
  },
  async created() {
    // pending인경우 complete로 전환시켜주는 코드를 넣는다.
    if (this.contractCurrent?.status === 'pending') {
    }
  },
  methods: {
    ...mapActions('contract', ['contractComplete']),
    next() {
      closeBrowser()
    },
  },
}
</script>
<style lang="scss" scoped>
#section__wait {
  text-align: center;

  .book {
    width: 100%;
    height: 208px;
    object-fit: contain;
  }

  .card {
    width: 100%;
    background-color: #e5f6ff;
  }
}
</style>
